export type SilenceAnalysis = {
  floor: number;
  p90: number;
  peak: number;
  spread: number;
  sampleCount: number;
  quality: "quiet" | "usable" | "retake";
  hasSpike: boolean;
};

export type NoiseCalibration = SilenceAnalysis & {
  deviceLabel: string;
  sampleRate: number;
  channelCount: number;
  preserveSoftTone: boolean;
};

function percentile(sorted: number[], ratio: number): number {
  if (!sorted.length) return 0;
  const index = Math.min(sorted.length - 1, Math.max(0, Math.ceil(sorted.length * ratio) - 1));
  return sorted[index];
}

export function analyzeSilenceLevels(levels: number[]): SilenceAnalysis {
  const sorted = levels.filter(Number.isFinite).map((value) => Math.max(0, value)).sort((a, b) => a - b);
  const floor = percentile(sorted, 0.5);
  const p90 = percentile(sorted, 0.9);
  const peak = sorted.at(-1) ?? 0;
  return {
    floor,
    p90,
    peak,
    spread: Math.max(0, p90 - floor),
    sampleCount: sorted.length,
    quality: p90 >= 0.035 ? "retake" : p90 >= 0.015 ? "usable" : "quiet",
    hasSpike: peak > Math.max(0.08, p90 * 4),
  };
}
